export default __webpack_public_path__ + "static/bt-screen-android-mobile-f5eef9cdc6e716c204c26a72ae078a0e.png";